
import genericService from '../genericService';

const urls = {
    CALCULATOR_HEADER: 'demurrage-calculator-header',
    CALCULATOR_DETAIL: 'demurrage-calculator-details',
    CALCULATOR_REASON: 'demurrage-calculator-reason',
    CALCULATOR_REASON_REPROPORTIONATE: 'demurrage-calculator-reason-reproportion',
    REGISTER: 'demurrage-register',
    COUNTERPARTY_REQUEST: 'demurrage-counterpary-request',
    NOTE_DISTINCT: 'demurrage-note-distinct',
    NOTE:'demurrage-note',
    CALCULATOR_EXCEL: 'demurrage-calculator-excel',
    REGISTER_EXCEL: 'demurrage-register-excel',
    EXCHANGE_RATE_AVG_MONTHLY: 'system/exchange-rate-monthly-average-rates',
    CALCULATOR_MAIL: 'demurrage-calculator-send-mail',
    UPLOAD_ATTACHMENT: 'demurrage-upload-file',
    RECAP: 'demurrage-recap',
    STATISTICS_PLANT: 'demurrage-statistics-plant',
    STATISTICS_CHARGE_DISCHARGE: 'demurrage-statistics-charge-discharge',
    STATISTICS_GRAPH: 'demurrage-statistics-graph',
    STATISTICS_PIVOT: 'demurrage-statistics-pivot',
    STATISTICS_PROGRESSIVE: 'demurrage-statistics-progressive',
    STATISTICS_ACT_VS_BUDGET: 'demurrage-act-vs-budget',
    STATISTICS_EXCEL: 'demurrage-statistics-excel',
    PLANNING_STRATEGY: 'demurrage-planning-strategy'
}

export default {
    async getCalculatorHeader(id, callback){
        await genericService.getItem(urls.CALCULATOR_HEADER, id).then(callback);
    },
    async updateCalculatorHeader(body, callback){
        await genericService.put(urls.CALCULATOR_HEADER, body).then(callback);
    },
    async createCalculatorHeader(id, callback){
        await genericService.post(urls.CALCULATOR_HEADER + '?idMovementInstructionHeader=' + id , null).then(callback);
    },
    async regenerateCalculatorHeader(id, force, callback){
        await genericService.post(urls.CALCULATOR_HEADER + '?idMovementInstructionHeader=' + id +'&force=' + force , null).then(callback);
    },
    async createCalculatorDeduction(body, callback){
        await genericService.post(urls.CALCULATOR_DETAIL, body).then(callback);
    },
    async getCalculatorDetail(id, callback){
        await genericService.getItem(urls.CALCULATOR_DETAIL, id).then(callback);
    },
    async getCalculatorDetailDeduction(id, callback){
        await genericService.get(urls.CALCULATOR_DETAIL + '?id=' + id , null).then(callback);
    },
    async deleteDeductionDetail(id, callback){
        await genericService.delete(urls.CALCULATOR_DETAIL, id).then(callback);
    },
    async updateDeductionDetail(body, callback){
        await genericService.put(urls.CALCULATOR_DETAIL, body).then(callback);
    },
    async getRegister(params, callback){
        await genericService.get(urls.REGISTER, params).then(callback);
    },
    async getRegisterById(id, callback){
        await genericService.getItem(urls.REGISTER, id).then(callback);
    },
    async updateRegister(body, callback){
        await genericService.put(urls.REGISTER, body).then(callback);
    },
    async updatePlanningStrategy(body, callback){
        await genericService.put(urls.PLANNING_STRATEGY, body).then(callback);
    },
    async getCounterPartyRequest(params, callback){
        await genericService.get(urls.COUNTERPARTY_REQUEST, params).then(callback);
    },
    async createCounterPartyRequest(body, callback){
        await genericService.post(urls.COUNTERPARTY_REQUEST, body).then(callback);
    },
    async deleteCounterPartyRequest(id, callback){
        await genericService.delete(urls.COUNTERPARTY_REQUEST, id).then(callback);
    },
    async getNoteDistinct(callback){
        await genericService.get(urls.NOTE_DISTINCT, null).then(callback);
    },
    async createNote(body, callback){
        await genericService.post(urls.NOTE, body).then(callback);
    },
    async deleteNote(id, callback){
        await genericService.delete(urls.NOTE, id).then(callback);
    },
    async exportCalculatorExcel(id, body, callback){
         await genericService.dowloadFile(urls.CALCULATOR_EXCEL + '/' + id , body).then(callback);
    },
    async exportRegisterExcel(body, callback){
         await genericService.dowloadFile(urls.REGISTER_EXCEL, body).then(callback);
    },
    async getExchangeRateAvgMonthly(body, callback){
        await genericService.get(urls.EXCHANGE_RATE_AVG_MONTHLY, body).then(callback);
    },
    async sendMail(body, callback){
        await genericService.post(urls.CALCULATOR_MAIL, body).then(callback);
    },
    async getCalculatorReason(id, callback){
        await genericService.getItem(urls.CALCULATOR_REASON, id).then(callback);
    },
    async deleteReason(id, callback){
        await genericService.delete(urls.CALCULATOR_REASON, id).then(callback);
    },
    async updateReason(body, callback){
        await genericService.put(urls.CALCULATOR_REASON, body).then(callback);
    },
    async createReason(body, callback){
        await genericService.post(urls.CALCULATOR_REASON, body).then(callback);
    },
    async uploadAttachment(body, callback){
        await genericService.post(urls.UPLOAD_ATTACHMENT, body).then(callback);
    },
    async getRecap(params, callback){
        await genericService.get(urls.RECAP, params).then(callback);
    },
    async getPlantStatistics(params, callback){
        await genericService.get(urls.STATISTICS_PLANT, params).then(callback);
    },
    async getChargeDischargeStatistics(params, callback){
        await genericService.get(urls.STATISTICS_CHARGE_DISCHARGE, params).then(callback);
    },
    async getGraphs(callback){
        await genericService.get(urls.STATISTICS_GRAPH, {}).then(callback);
    },
    async updateGraph(body, callback){
        await genericService.put(urls.STATISTICS_GRAPH, body).then(callback);
    },
    async deleteGraph(id, callback){
        await genericService.delete(urls.STATISTICS_GRAPH, id).then(callback);
    },
    async createGraph(body, callback){
        await genericService.post(urls.STATISTICS_GRAPH, body).then(callback);
    },
    async getPivot(body, callback){
        await genericService.post(urls.STATISTICS_PIVOT, body).then(callback);
    },
    async getProgressive(params, callback){
        await genericService.get(urls.STATISTICS_PROGRESSIVE, params).then(callback);
    },
    async getActVsBudget(params, callback){
        await genericService.get(urls.STATISTICS_ACT_VS_BUDGET, params).then(callback);
    },
    async updateActVsBudget(body, callback){
        await genericService.put(urls.STATISTICS_ACT_VS_BUDGET, body).then(callback);
    },
    async createActVsBudget(body, callback){
        await genericService.post(urls.STATISTICS_ACT_VS_BUDGET, body).then(callback);
    },
    async exportStatisticsExcel(params, callback){
        await genericService.dowloadFile(urls.STATISTICS_EXCEL, params).then(callback);
    },
    async reproportionateReasons(id, callback){
        await genericService.post(urls.CALCULATOR_REASON_REPROPORTIONATE + '?headerId=' + id, {}).then(callback);
    },
    
}